import axios from  'axios'

  //const baseURL= "http://3.109.148.179/Toms_customer_connect/api/"
  //const baseURL= "http://192.168.1.50:8089/api/"
 // const baseURL= "http://localhost:8089/api/"
  // const baseURL= "http://localhost:8089/api/"
  const baseURL= "http://targettest.asktek.net/toms.pogen.webapi/api/"

  //const baseURL= "http://desktop-o3684s3:8089/api/"
const instance = axios.create({
    baseURL
   
})


export default  {
  instance ,
  baseURL
}
